<template>
  <div>
  <v-toolbar-title v-if="isEstablecimientoSet && !mobile">
    <fh-menu-establecimiento></fh-menu-establecimiento>
    <v-btn-toggle color="primary" dense>
      <v-btn :class="agroActive"  @click="handleAgroClick()" v-if="hasCategoriaAgricultura" depressed>Agro<v-icon small right>fa-seedling</v-icon></v-btn>
      <v-btn :class="ganaderiaActive" @click="handleGanaderiaClick()" v-if="hasCategoriaGanaderia" depressed>Ganadería<v-icon right>{{cowIcon}}</v-icon></v-btn>
    </v-btn-toggle>
    <v-btn class="ml-4" @click="handleEstConfClick()" icon >
      <!-- <v-badge v-if="parcelas.length === 0 && currentCategoria === 2" color="error" dot><v-icon color="black" small>fa-cogs</v-icon></v-badge> -->
      <v-icon color="black" small>fa-cogs</v-icon>
    </v-btn>
  </v-toolbar-title>
  <template v-else-if="isEstablecimientoSet && mobile">
    <div v-touch="{up:()=> swipe('UP'), down: () => swipe('Down')}" @click="handleHomeClick()" class="text-break fh-cursor-pointer body-1">{{establecimiento.nombre}}</div>
    <!-- <div @click="handleHomeClick()" class="text-break fh-cursor-pointer body-1">{{establecimiento.nombre}}</div> -->
  </template>
  <v-toolbar-title
    v-else
    @click="handleHomeClick()"
  >
    Agro
  </v-toolbar-title>
  </div>
</template>

<script>  
import { mdiCow } from '@mdi/js'
import {mapActions, mapGetters, mapState} from 'vuex'
import FhMenuEstablecimiento from '@/components/app/FhMenuEstablecimiento.vue'

export default {
  components: { FhMenuEstablecimiento },
  name: 'FhSwitchCategoria',
  props: {
    mobile: Boolean
  },
  data(){
    return {
      cowIcon: mdiCow
    }
  },
  computed: {
    ...mapState('session', [
      'isRestored',
    ]),
    ...mapGetters('establecimientos',[
      'isEstablecimientoSet',
      'hasCategoriaAgricultura',
      'hasCategoriaGanaderia',
      'currentCategoria',
      'nextEstablecimiento',
      'previousEstablecimiento'
    ]),
    ...mapState('establecimientos', [
      'establecimiento',
      'establecimientosList'
    ]),
    
    ...mapState('fichas',[
      'parcelas'
    ]),
    agroActive(){
      return (this.currentCategoria === 1 || this.$route.path.includes('/agro')) ? 'v-btn--active' : 'no-active'
    },
    ganaderiaActive(){
      return (this.currentCategoria === 2 || this.$route.path.includes('/ganaderia')) ? 'v-btn--active' : 'no-active'
    },
  },
  methods: {
    ...mapActions('establecimientos',[
      'changeGrupoExplotacion',
      'clearEstablecimiento',
      'setEstablecimiento'
    ]),
    ...mapActions('fichas',[
      'fetchFichaGanadera',
    ]),
    handleEstConfClick() {
      this.$router.push({name: 'ConfiguracionEstablecimientos'}).catch(() => {})
    },
    handleAgroClick() {
      if(this.currentCategoria !== 1){
        this.changeGrupoExplotacion()
      }
      this.$router.push({name: 'AgroHome'}).catch(() => {})
    },
    handleGanaderiaClick() {
      if(this.currentCategoria !== 2){
        this.changeGrupoExplotacion()
      }
      this.$router.push({name: 'GanaderiaHome'}).catch(() => {})
    },
    handleHomeClick(){
      if(this.currentCategoria === 1){
        this.$router.push({name: 'AgroHome'}).catch(() => {})
      }
      else{
        this.$router.push({name: 'GanaderiaHome'}).catch(() => {})
      }
    },
    async swipe(direction){
      if(this.establecimientosList.length <= 1){
        return
      }
      if(direction === 'Down'){
        let temp = this.nextEstablecimiento
        if(temp){
          await this.clearEstablecimiento()
          await this.setEstablecimiento(temp)
          if(this.currentCategoria === 1){
            this.$router.push({name: 'AgroHome'}).catch(() => {})
          }
          else{
            this.$router.push({name: 'GanaderiaHome'}).catch(() => {})
          }
        }
      }else{
        let temp = this.previousEstablecimiento
        if(temp){
          await this.clearEstablecimiento()
          await this.setEstablecimiento(temp)
          if(this.currentCategoria === 1){
            this.$router.push({name: 'AgroHome'}).catch(() => {})
          }
          else{
            this.$router.push({name: 'GanaderiaHome'}).catch(() => {})
          }
        }
      }
    },
  },
  async created (){
    while (!this.isRestored) {
      await this.$sleep(10)
    }
    // await this.fetchFichaGanadera()
  },
}
</script>
<style scoped>
  .fh-cursor-pointer {
    cursor: pointer;
    line-height: 100%;
  }
</style>